export const ExpediaBannerLinkConfig = {
  'us-expedia': {
    home: 'https://www.expedia.com/?siteid=1&langid=1033',
    activities: 'https://www.expedia.com/Activities?siteid=1&langid=1033',
    cars: 'https://www.expedia.com/Cars?siteid=1&langid=1033',
    cruises: 'https://www.expedia.com/Cruises?siteid=1&langid=1033',
    flights: 'https://www.expedia.com/Flights?siteid=1&langid=1033',
    packages: 'https://www.expedia.com/Vacation-Packages?siteid=1&langid=1033',
    stays: 'https://www.expedia.com/Hotels?siteid=1&langid=1033',
  },
  'uk-expedia': {
    home: 'https://www.expedia.co.uk/?langid=1033&siteid=3',
    activities: 'https://www.expedia.co.uk/Activities?langid=1033&siteid=3',
    cars: 'https://www.expedia.co.uk/Cars?langid=1033&siteid=3',
    cruises: 'https://www.expedia.co.uk/Cruises?langid=1033&siteid=3',
    flights: 'https://www.expedia.co.uk/Flights?langid=1033&siteid=3',
    packages: 'https://www.expedia.co.uk/Vacation-Packages?langid=1033&siteid=3',
    stays: 'https://www.expedia.co.uk/Hotels?langid=1033&siteid=3',
  },
  'ca-expedia': {
    home: 'https://www.expedia.ca/?langid=1033&siteid=4',
    activities: 'https://www.expedia.ca/Activities?langid=1033&siteid=4',
    cars: 'https://www.expedia.ca/Cars?langid=1033&siteid=4',
    cruises: 'https://www.expedia.ca/Cruises?langid=1033&siteid=4',
    flights: 'https://www.expedia.ca/Flights?langid=1033&siteid=4',
    packages: 'https://www.expedia.ca/Vacation-Packages?langid=1033&siteid=4',
    stays: 'https://www.expedia.ca/Hotels?langid=1033&siteid=4',
  },
  'au-expedia': {
    home: 'https://www.expedia.com.au/?langid=1033&siteid=25',
    activities: 'https://www.expedia.com.au/Activities?langid=1033&siteid=25',
    cars: 'https://www.expedia.com.au/Cars?langid=1033&siteid=25',
    cruises: 'https://www.expedia.com.au/Cruises?langid=1033&siteid=25',
    flights: 'https://www.expedia.com.au/Flights?langid=1033&siteid=25',
    packages: 'https://www.expedia.com.au/Vacation-Packages?langid=1033&siteid=25',
    stays: 'https://www.expedia.com.au/Hotels?langid=1033&siteid=25',
  },
  'fr-expedia': {
    home: 'https://www.expedia.fr/?langid=1036&siteid=20',
    activities: 'https://www.expedia.fr/Activities?langid=1036&siteid=20',
    cars: 'https://www.expedia.fr/Cars?langid=1036&siteid=20',
    cruises: 'https://www.expedia.fr/Cruises?langid=1036&siteid=20',
    flights: 'https://www.expedia.fr/Flights?langid=1036&siteid=20',
    packages: 'https://www.expedia.fr/Vacation-Packages?langid=1036&siteid=20',
    stays: 'https://www.expedia.fr/Hotels?langid=1036&siteid=20',
  },
  'de-expedia': {
    home: 'https://www.expedia.de/?langid=1031&siteid=6',
    activities: 'https://www.expedia.de/Activities?langid=1031&siteid=6',
    cars: 'https://www.expedia.de/Cars?langid=1031&siteid=6',
    cruises: 'https://www.expedia.de/Cruises?langid=1031&siteid=6',
    flights: 'https://www.expedia.de/Flights?langid=1031&siteid=6',
    packages: 'https://www.expedia.de/Vacation-Packages?langid=1031&siteid=6',
    stays: 'https://www.expedia.de/Hotels?langid=1031&siteid=6',
  },
  'mx-expedia': {
    home: 'https://www.expedia.mx/?langid=2058&siteid=12',
    activities: 'https://www.expedia.mx/Activities?langid=2058&siteid=12',
    cars: 'https://www.expedia.mx/Cars?langid=2058&siteid=12',
    cruises: 'https://www.expedia.mx/Cruises?langid=2058&siteid=12',
    flights: 'https://www.expedia.mx/Flights?langid=2058&siteid=12',
    packages: 'https://www.expedia.mx/Vacation-Packages?langid=2058&siteid=12',
    stays: 'https://www.expedia.mx/Hotels?langid=2058&siteid=12',
  },
  'jp-expedia': {
    home: 'https://www.expedia.co.jp/?langid=1041&siteid=28',
    activities: 'https://www.expedia.co.jp/Activities?langid=1041&siteid=28',
    cars: 'https://www.expedia.co.jp/Cars?langid=1041&siteid=28',
    cruises: 'https://www.expedia.co.jp/Cruises?langid=1041&siteid=28',
    flights: 'https://www.expedia.co.jp/Flights?langid=1041&siteid=28',
    packages: 'https://www.expedia.co.jp/Vacation-Packages?langid=1041&siteid=28',
    stays: 'https://www.expedia.co.jp/Hotels?langid=1041&siteid=28',
  },
  'kr-expedia': {
    home: 'https://www.expedia.co.kr/?langid=1042&siteid=16',
    activities: 'https://www.expedia.co.kr/Activities?langid=1042&siteid=16',
    cars: 'https://www.expedia.co.kr/Cars?langid=1042&siteid=16',
    cruises: 'https://www.expedia.co.kr/Cruises?langid=1042&siteid=16',
    flights: 'https://www.expedia.co.kr/Flights?langid=1042&siteid=16',
    packages: 'https://www.expedia.co.kr/Vacation-Packages?langid=1042&siteid=16',
    stays: 'https://www.expedia.co.kr/Hotels?langid=1042&siteid=16',
  },
  'hk-expedia': {
    home: 'https://www.expedia.com.hk/?langid=3076&siteid=18',
    activities: 'https://www.expedia.com.hk/Activities?langid=3076&siteid=18',
    cars: 'https://www.expedia.com.hk/Cars?langid=3076&siteid=18',
    cruises: 'https://www.expedia.com.hk/Cruises?langid=3076&siteid=18',
    flights: 'https://www.expedia.com.hk/Flights?langid=3076&siteid=18',
    packages: 'https://www.expedia.com.hk/Vacation-Packages?langid=3076&siteid=18',
    stays: 'https://www.expedia.com.hk/Hotels?langid=3076&siteid=18',
  },
  'sg-expedia': {
    home: 'https://www.expedia.com.sg/?langid=3076&siteid=14',
    activities: 'https://www.expedia.com.sg/Activities?langid=3076&siteid=14',
    cars: 'https://www.expedia.com.sg/Cars?langid=3076&siteid=14',
    cruises: 'https://www.expedia.com.sg/Cruises?langid=3076&siteid=14',
    flights: 'https://www.expedia.com.sg/Flights?langid=3076&siteid=14',
    packages: 'https://www.expedia.com.sg/Vacation-Packages?langid=3076&siteid=14',
    stays: 'https://www.expedia.com.sg/Hotels?langid=3076&siteid=14',
  },
  'nz-expedia': {
    home: 'https://www.expedia.co.nz/?langid=1033&siteid=29',
    activities: 'https://www.expedia.co.nz/Activities?langid=1033&siteid=29',
    cars: 'https://www.expedia.co.nz/Cars?langid=1033&siteid=29',
    cruises: 'https://www.expedia.co.nz/Cruises?langid=1033&siteid=29',
    flights: 'https://www.expedia.co.nz/Flights?langid=1033&siteid=29',
    packages: 'https://www.expedia.co.nz/Vacation-Packages?langid=1033&siteid=29',
    stays: 'https://www.expedia.co.nz/Hotels?langid=1033&siteid=29',
  },
};
